module.exports = __webpack_public_path__ + "img/Agus.15511f48.jpg";